import API from 'common-ui-components/components/utils/API'
import { isLocalhost } from 'common-ui-components/components/utils/Config';

let filterContent = null;
export const getCommonGroupFilters = async () => {
    let storedFilter=localStorage.getItem("CommonGroupsFilter");
    if(storedFilter)
        return JSON.parse(storedFilter);
    else
    {
        try 
        {
            //const response = await API.get(isLocalhost ? "/inventory/getFilterQueries?entityType=GROUPS" : "");
            const response = await API.get("/inventory/getFilterQueries?entityType=GROUPS");

            if (response.status.success) 
            {
                const result = response.body.map(item => {
                    const [key, value] = Object.entries(item)[0];

                    return {
                        label: key,
                        value: value
                    };
                });

                filterContent = {
                    heading: "Groups",
                    column: "group",
                    type: "multiple",
                    options: result
                };

                localStorage.setItem("CommonGroupsFilter",JSON.stringify(filterContent))
            }

            return filterContent;
        }
        catch (error) 
        {
            console.error("Error fetching group filters:", error);
            return null;
        }
    }
};

export const CommonGroupsFilter = () => {
    return null;
}